import type { Ref } from "vue";

import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

export function useTeacherPageMetaData(teacher: Ref<TeacherPageView>) {
  const {
    public: {
      cloudinary,
      apps: { websiteBaseUrl },
    },
  } = useRuntimeConfig();
  useSeoMeta({
    title() {
      return `${teacher.value.full_name}, ${teacher.value.job}`;
    },
    description() {
      return teacher.value.description;
    },
    ogImage() {
      return teacher.value.avatar_url.replace(
        cloudinary.baseUrl,
        `${cloudinary.baseUrl}w_1200,h_1200,c_fill,q_auto/`,
      );
    },
    robots() {
      return teacher.value.indexed ? undefined : "noindex";
    },
  });

  useSchemaOrg([
    definePerson({
      name: teacher.value?.full_name ?? "",
      image: teacher.value?.avatar_url,
      url: `${websiteBaseUrl}/trainers/${teacher.value?.slug}`,
    }),
  ]);
}
